"use client";
import {
  captureWithSentry
} from "./chunk-6YPFPWLT.js";
import "./chunk-FQGVY4KD.js";

// src/client.ts
import * as Sentry from "@sentry/nextjs";
var ClientErrorTracker = class {
  async captureError(error, options = {}) {
    return captureWithSentry(error, options);
  }
  /** Attributes later events to an opaque user id (never an email or name). */
  setUser(userId, organizationId) {
    Sentry.setUser({ id: userId });
    if (organizationId) {
      Sentry.setTag("organization_id", organizationId);
    }
  }
  addBreadcrumb(message, category = "default", data) {
    Sentry.addBreadcrumb({ message, category, data });
  }
  /**
   * Opens the Sentry feedback form, tagged with the error it relates to.
   * Resolves `false` when Sentry is disabled so callers can hide the option.
   */
  async openFeedbackForm(errorEventId) {
    const feedback = Sentry.getFeedback();
    if (!feedback) {
      return false;
    }
    const form = await feedback.createForm({
      ...errorEventId ? { tags: { error_event_id: errorEventId } } : {},
      onFormClose: () => form.removeFromDom()
    });
    form.appendToDom();
    form.open();
    return true;
  }
  isFeedbackAvailable() {
    return Boolean(Sentry.getFeedback());
  }
};
var clientErrorTracker = new ClientErrorTracker();
export {
  clientErrorTracker
};
